<template>
  <vx-card v-if="generalInfo && activeVenue" no-shadow>
    <h2 class="mb-6">General</h2>

    <div class="vx-row mb-6">
      <div class="vx-col sm:w-1/5 w-full">
        <span>Active</span>
      </div>
      <div class="vx-col">
        <vs-switch color="success" v-model="generalInfo.venueStatus" />
      </div>
    </div>

    <div class="vx-row mb-6">
      <div class="vx-col sm:w-1/5 w-full">
        <span>Webi entity ID</span>
      </div>
      <div class="vx-col sm:w-2/5 w-full">
        <p>{{ generalInfo.webiId }}</p>
      </div>
    </div>

    <div class="vx-row mb-6">
      <div class="vx-col sm:w-1/5 w-full">
        <span>Venue name</span>
      </div>
      <div class="vx-col sm:w-2/5 w-full">
        <vs-input class="w-full" v-model="generalInfo.name" />
      </div>
    </div>

    <div class="vx-row mb-6">
      <div class="vx-col sm:w-1/5 w-full">
        <span>Short name</span>
      </div>
      <div class="vx-col sm:w-2/5 w-full">
        <vs-input class="w-full" v-model="generalInfo.shortName" />
      </div>
    </div>

    <div class="vx-row mb-6">
      <div class="vx-col sm:w-1/5 w-full">
        <span>Venue Type</span>
      </div>
      <div class="vx-col sm:w-2/5 w-full">
        <vs-input
          class="w-full"
          placeholder="Eg. Nightclub 20+"
          v-model="generalInfo.venueType"
        />
      </div>
    </div>

    <div class="vx-row mb-6">
      <div class="vx-col sm:w-1/5 w-full">
        <span>Description</span>
      </div>
      <div class="vx-col sm:w-2/5 w-full">
        <textarea
          class="vs-inputx vs-input--input normal"
          style="height: 200px; font-family: Arial; line-height: 1.5rem"
          spellcheck="false"
          v-model="generalInfo.description"
          placeholder="Venue description..."
        />
      </div>
    </div>

    <div class="vx-row mb-6">
      <div class="vx-col sm:w-1/5 w-full">
        <span>E-mail</span>
      </div>
      <div class="vx-col sm:w-2/5 w-full">
        <vs-input class="w-full" v-model="generalInfo.email" />
      </div>
    </div>

    <div class="vx-row mb-6">
      <div class="vx-col sm:w-1/5 w-full">
        <span>Website</span>
      </div>
      <div class="vx-col sm:w-2/5 w-full">
        <vs-input class="w-full" v-model="generalInfo.website" />
      </div>
    </div>

    <div class="vx-row mb-6">
      <div class="vx-col sm:w-1/5 w-full">
        <span>Phone</span>
      </div>
      <div class="vx-col sm:w-2/5">
        <vs-row>
          <vs-select width="100px" v-model="generalInfo.phoneCountryCode">
            <vs-select-item
              :key="index"
              :value="item.value"
              :text="item.text"
              v-for="(item, index) in phoneCodeOptions"
            />
          </vs-select>
          <vs-input class="ml-3" v-model="generalInfo.phone" />
        </vs-row>
      </div>
    </div>

    <div class="vx-row mb-6">
      <div class="vx-col sm:w-1/5 w-full">
        <span>VAT number</span>
      </div>
      <div class="vx-col sm:w-2/5 w-full">
        <vs-input class="w-full" v-model="generalInfo.vat" />
      </div>
    </div>

    <div class="vx-row mb-6">
      <div class="vx-col sm:w-1/5 w-full">
        <span>Bank info</span>
      </div>
      <div class="vx-col sm:w-2/5 w-full">
        <vs-input class="w-full" v-model="generalInfo.bankAccount" />
      </div>
    </div>

    <div class="vx-row mb-6">
      <div class="vx-col sm:w-1/5 w-full">
        <span>Venue size (m2)</span>
      </div>
      <div class="vx-col">
        <vs-input-number v-model="generalInfo.size" label="m2" />
      </div>
    </div>

    <div class="vx-row mb-6">
      <div class="vx-col sm:w-1/5 w-full">
        <span>Max Capacity</span>
      </div>
      <div class="vx-col">
        <vs-input-number label="Guests" v-model="generalInfo.capacity" />
      </div>
    </div>

    <vs-divider />

    <div class="vx-col lg:w-1/1 w-full">
      <h5 class="mb-6">Tags</h5>
    </div>

    <div class="vx-row mb-6">
      <div class="vx-col sm:w-1/5 w-full">
        <span>Tags</span>
      </div>
      <div class="vx-col sm:w-4/5 w-full">
        <vs-chips
          color="rgb(145, 32, 159)"
          placeholder="New Tag"
          v-model="generalInfo.tags"
        >
          <vs-chip
            :key="tag"
            @click="removeTag(tag, generalInfo.tags)"
            v-for="tag in generalInfo.tags"
            closable
          >
            {{ tag }}
          </vs-chip>
        </vs-chips>
      </div>
    </div>

    <vs-divider />

    <div class="vx-col lg:w-1/1 w-full">
      <h5 class="mb-6">Tobacco info</h5>
    </div>

    <div class="vx-row mb-6">
      <div class="vx-col sm:w-1/5 w-full">
        <span>Mandatory info</span>
      </div>
      <div class="vx-col sm:w-4/5 w-full">
        <vs-row>
          <vs-input
            placeholder="Entity number"
            label="Entity number"
            class="mr-2"
            v-model="generalInfo.tobaccoInfo.entityNumber"
          />
          <vs-input
            placeholder="Entity code"
            label="Entity code"
            class="mr-2"
            v-model="generalInfo.tobaccoInfo.entityCode"
          />
          <vs-input
            placeholder="Facility code"
            label="Facility code"
            class="mr-2"
            v-model="generalInfo.tobaccoInfo.facilityCode"
          />
        </vs-row>
      </div>
    </div>

    <vs-divider />

    <div class="vx-col lg:w-1/1 w-full">
      <h5 class="mb-6">Licensed managers</h5>
    </div>

    <div class="vx-row mb-6">
      <div class="vx-col sm:w-1/5 w-full">
        <span>Licensed manaagers</span>
      </div>
      <div class="vx-col sm:w-4/5 w-full">
        <vs-chips
          color="rgb(145, 32, 159)"
          placeholder="New licensed manager"
          v-model="generalInfo.licensedManagers.names"
        >
          <vs-chip
            :key="tag"
            @click="removeTag(tag, generalInfo.licensedManagers.names)"
            v-for="tag in generalInfo.licensedManagers.names"
            closable
          >
            {{ tag }}
          </vs-chip>
        </vs-chips>
      </div>
    </div>

    <div class="vx-row mb-6">
      <div class="vx-col sm:w-1/5 w-full">
        <span>Note</span>
      </div>
      <div class="vx-col sm:w-2/5 w-full">
        <vs-input class="w-full" v-model="generalInfo.licensedManagers.note" />
      </div>
    </div>

    <vs-divider />

    <div class="vx-col lg:w-1/1 w-full">
      <h5 class="mb-6">Cleaning duty</h5>
    </div>

    <div class="vx-row mb-6">
      <div class="vx-col sm:w-1/5 w-full">
        <span>General sidewalk cleaning</span>
      </div>
      <div class="vx-col sm:w-2/5 w-full">
        <vs-switch
          color="success"
          v-model="generalInfo.cleaningDuty.generalSidewalkCleaning"
        />
      </div>
    </div>

    <div class="vx-row mb-6">
      <div class="vx-col sm:w-1/5 w-full">
        <span>Snow shovelling</span>
      </div>
      <div class="vx-col sm:w-2/5 w-full">
        <vs-switch
          color="success"
          v-model="generalInfo.cleaningDuty.snowShoveling"
        />
      </div>
    </div>

    <div class="vx-row mb-6">
      <div class="vx-col sm:w-1/5 w-full">
        <span>Note</span>
      </div>
      <div class="vx-col sm:w-2/5 w-full">
        <vs-input class="w-full" v-model="generalInfo.cleaningDuty.note" />
      </div>
    </div>

    <vs-divider />

    <div class="vx-col lg:w-1/1 w-full">
      <h5 class="mb-2">Additional contact</h5>
      <p class="mb-6">See 'Contacts' tab for position contacts.</p>
    </div>

    <div class="vx-row mb-6" v-for="(p, idx) in contactPeople" :key="idx">
      <div class="vx-col sm:w-1/5 w-full">
        <span>{{ p.name }}</span>
      </div>
      <div class="vx-col sm:w-4/5 w-full">
        <vs-row>
          <vs-input
            placeholder="Full name"
            class="mr-2"
            v-model="generalInfo[p.key].name"
          />
          <vs-input
            placeholder="Phone number"
            class="mr-2"
            v-model="generalInfo[p.key].phone"
          />
          <vs-input
            placeholder="E-mail"
            class="mr-2"
            v-model="generalInfo[p.key].mail"
          />
          <vs-input
            placeholder="Note"
            class="mt-2"
            v-model="generalInfo[p.key].note"
          />
        </vs-row>
      </div>
    </div>

    <vs-divider />

    <div class="vx-col lg:w-1/1 w-full">
      <h5 class="mb-6">Entrance & wardrobe</h5>
    </div>

    <div class="vx-row mb-6">
      <div class="vx-col sm:w-1/5 w-full">
        <span>Entrance</span>
      </div>
      <div class="vx-col sm:w-4/5 w-full">
        <vs-row>
          <vs-input
            placeholder="When"
            label="When"
            class="mr-2"
            v-model="generalInfo.entrance.when"
          />
          <vs-input
            placeholder="Price (in local currency)"
            label="Price"
            class="mr-2"
            v-model="generalInfo.entrance.price"
          />
          <vs-input
            placeholder="Note"
            label="Note"
            class="mr-2"
            v-model="generalInfo.entrance.note"
          />
        </vs-row>
      </div>
    </div>

    <div class="vx-row mb-6">
      <div class="vx-col sm:w-1/5 w-full">
        <span>Wardrobe</span>
      </div>
      <div class="vx-col sm:w-4/5 w-full">
        <vs-row>
          <vs-input
            placeholder="When"
            label="When"
            class="mr-2"
            v-model="generalInfo.wardrobe.when"
          />
          <vs-input
            placeholder="Price (in local currency)"
            label="Price"
            class="mr-2"
            v-model="generalInfo.wardrobe.price"
          />
          <vs-input
            placeholder="Note"
            label="Note"
            class="mr-2"
            v-model="generalInfo.wardrobe.note"
          />
        </vs-row>
      </div>
    </div>

    <vs-divider />

    <div class="vx-col lg:w-1/1 w-full">
      <h5 class="mb-6">Private area</h5>
    </div>

    <div class="vx-row mb-6">
      <div class="vx-col sm:w-1/5 w-full">
        <span>Possible to rent</span>
      </div>
      <div class="vx-col sm:w-2/5 w-full">
        <vs-switch
          color="success"
          v-model="generalInfo.privateArea.possibleToRent"
        />
      </div>
    </div>

    <div class="vx-row mb-6">
      <div class="vx-col sm:w-1/5 w-full">
        <span>Possible to dine</span>
      </div>
      <div class="vx-col sm:w-2/5 w-full">
        <vs-switch
          color="success"
          v-model="generalInfo.privateArea.possibleToDine"
        />
      </div>
    </div>

    <div class="vx-row mb-6">
      <div class="vx-col sm:w-1/5 w-full">
        <span>Offers</span>
      </div>
      <div class="vx-col sm:w-2/5 w-full">
        <vs-input
          placeholder="Offers"
          class="mr-2"
          v-model="generalInfo.privateArea.offers"
        />
      </div>
    </div>

    <div class="vx-row mb-6">
      <div class="vx-col sm:w-1/5 w-full">
        <span>Other</span>
      </div>
      <div class="vx-col sm:w-2/5 w-full">
        <vs-input
          placeholder="Other"
          class="mr-2"
          v-model="generalInfo.privateArea.other"
        />
      </div>
    </div>

    <vs-divider />

    <div class="vx-col lg:w-1/1 w-full">
      <h5 class="mb-6">FAQ</h5>
    </div>

    <div class="vx-row mb-6" v-for="qa in generalInfo.faq" :key="qa.key">
      <div class="vx-col sm:w-1/5 w-full">
        <span>{{ qa.key }}</span>
        <feather-icon
          @click="deleteFaq(qa.key)"
          icon="XIcon"
          svgClasses="h-4 w-4"
          class="cursor-pointer ml-1"
          size="small"
        ></feather-icon>
      </div>
      <div class="vx-col sm:w-4/5 w-full">
        <p>{{ qa.value }}</p>
      </div>
    </div>

    <div class="vx-row mb-6">
      <div class="vx-col sm:w-1/5 w-full">
        <span>New QA</span>
      </div>
      <div class="vx-col sm:w-4/5 w-full">
        <vs-row>
          <vs-input placeholder="Question" class="mr-2" v-model="newQuestion" />
          <vs-input placeholder="Answer" class="mr-2" v-model="newAnswer" />
          <vs-button
            :disabled="newQuestion === '' || newAnswer === ''"
            @click="submitQA"
            >Add</vs-button
          >
        </vs-row>
      </div>
    </div>

    <vs-divider />

    <div class="vx-col lg:w-1/1 w-full">
      <h5 class="mb-6">Lost & found</h5>
    </div>

    <div class="vx-row mb-6">
      <div class="vx-col sm:w-1/5 w-full">
        <span>Message in Danish</span>
      </div>
      <div class="vx-col sm:w-4/5 w-full">
        <vs-textarea
          placeholder="Lost and found message in Danish"
          class="mr-2"
          v-model="generalInfo.lostFoundMessageToGuestDK"
        />
      </div>
    </div>

    <div class="vx-row mb-6">
      <div class="vx-col sm:w-1/5 w-full">
        <span>Message in English</span>
      </div>
      <div class="vx-col sm:w-4/5 w-full">
        <vs-textarea
          placeholder="Lost and found message in English"
          class="mr-2"
          v-model="generalInfo.lostFoundMessageToGuestEN"
        />
      </div>
    </div>

    <vs-divider />

    <div class="vx-col lg:w-1/1 w-full">
      <h5 class="mb-6">Continia</h5>
    </div>

    <div class="vx-row mb-6">
      <div class="vx-col sm:w-1/5 w-full">
        <span>Code / ID</span>
      </div>
      <div class="vx-col sm:w-2/5 w-full">
        <vs-input class="w-full" v-model="generalInfo.continiaInfo.code" />
      </div>
    </div>

    <div class="vx-row mb-6">
      <div class="vx-col sm:w-1/5 w-full">
        <span>Venue Code</span>
      </div>
      <div class="vx-col sm:w-2/5 w-full">
        <vs-input class="w-full" v-model="generalInfo.continiaInfo.venueCode" />
      </div>
    </div>

    <div class="vx-row mb-6">
      <div class="vx-col sm:w-1/5 w-full">
        <span>Company</span>
      </div>
      <div class="vx-col sm:w-2/5 w-full">
        <vs-input class="w-full" v-model="generalInfo.continiaInfo.company" />
      </div>
    </div>

    <div class="vx-row mb-6">
      <div class="vx-col sm:w-1/5 w-full">
        <span>Invoice Email</span>
      </div>
      <div class="vx-col sm:w-2/5 w-full">
        <vs-input
          class="w-full"
          v-model="generalInfo.continiaInfo.invoiceEmail"
        />
      </div>
    </div>

    <vs-divider />

    <div class="vx-col lg:w-1/1 w-full">
      <h5 class="mb-6">Social media</h5>
    </div>

    <div class="vx-row mb-6">
      <div class="vx-col sm:w-1/5 w-full">
        <span>Facebook link</span>
      </div>
      <div class="vx-col sm:w-2/5 w-full">
        <vs-input class="w-full" v-model="generalInfo.facebookLink" />
      </div>
    </div>

    <div class="vx-row mb-6">
      <div class="vx-col sm:w-1/5 w-full">
        <span>Instagram link</span>
      </div>
      <div class="vx-col sm:w-2/5 w-full">
        <vs-input class="w-full" v-model="generalInfo.instagramLink" />
      </div>
    </div>

    <vs-divider />

    <div class="vx-col lg:w-1/1 w-full">
      <h5 class="mb-6">Styling <small>(CRM)</small></h5>
    </div>

    <div class="vx-row mb-6" v-for="(item, index) in colors" :key="index">
      <div class="vx-col sm:w-1/5 w-full">
        <span>{{ colorNames[index] }}</span>
      </div>
      <div class="vx-col">
        <input v-model="generalInfo.style[item]" type="color" />
      </div>
    </div>

    <div class="vx-row mb-6">
      <div class="vx-col sm:w-1/5 w-full">
        <span>Border radius</span>
      </div>
      <div class="vx-col">
        <vs-input-number v-model="generalInfo.style.borderRadius" label="px" />
      </div>
    </div>

    <div class="vx-row mb-6">
      <div class="vx-col sm:w-1/5 w-full">
        <span>Logo URL</span>
      </div>
      <div class="vx-col sm:w-2/5 w-full">
        <vs-input class="w-full" v-model="generalInfo.logoUrl" />
      </div>
    </div>

    <vs-divider />

    <div class="vx-col lg:w-1/1 w-full">
      <h5>Photos &amp; Videos</h5>
    </div>
    <VenueImages
      v-if="generalInfo"
      :venueId="activeVenue.venueId"
      :venue="generalInfo"
      style="width: 100%"
    />

    <!-- Save & Reset Button -->
    <div class="flex flex-wrap items-center justify-end">
      <vs-button
        v-if="$AuthService.hasPermissionForActiveVenue('vp.vp.venueinfo.edit')"
        @click="saveInfo"
        id="save-button"
        class="ml-auto mt-2"
        >Save General</vs-button
      >
    </div>
  </vx-card>
</template>

<script>
import { mapGetters } from "vuex";
const VenueImages = () => import("./VenueImages.vue");
export default {
  components: { VenueImages },

  data() {
    return {
      newQuestion: "",
      newAnswer: "",
      colors: [
        "colorBackground",
        "colorFont",
        "colorPrimaryCta",
        "colorPrimaryCtaFont",
        "colorBackgroundFields",
        "colorBackgroundPage",
        "colorBorder",
        "colorBorderBottom",
        "colorFieldsInput",
        "colorFieldsLabels",
        "colorFieldsPlaceholders",
        "colorPrices",
      ],
      colorNames: [
        "Background color",
        "Font color",
        "Primary CTA color",
        "Primary CTA font color",
        "Background fields color",
        "Background page color",
        "Border color",
        "Border bottom color",
        "Fields input color",
        "Fields label color",
        "Field placeholder color",
        "Prices color",
      ],
      contactPeople: [
        {
          key: "snrChannelActivationManager",
          name: "Snr Channel Activation Manager",
        },
        {
          key: "channelActivationManager",
          name: "Channel Activation Manager",
        },
        {
          key: "siteManager",
          name: "Site manager",
        },
        {
          key: "generalInquiries",
          name: "General inquriries",
        },
        {
          key: "bookingContact",
          name: "Booking",
        },
        {
          key: "lostAndFoundContact",
          name: "Lost and found",
        },
        {
          key: "landlordContact",
          name: "Landlord",
        },
        {
          key: "powerSupplier",
          name: "Power supplier",
        },
      ],
      phoneCodeOptions: [
        { text: "+45 DK", value: "+45" },
        { text: "+47 NO", value: "+47" },
        { text: "+358 FI", value: "+358" },
      ],
    };
  },
  computed: {
    ...mapGetters({
      generalInfo: "venues/generalInfo",
      activeVenue: "venues/activeVenue",
    }),
  },
  methods: {
    deleteFaq(key) {
      if (confirm("Sure you want to delete this question?"))
        this.generalInfo.faq = this.generalInfo.faq.filter(
          (e) => e.key !== key
        );
    },
    submitQA() {
      this.generalInfo.faq.push({
        key: this.newQuestion,
        value: this.newAnswer,
      });
      this.newQuestion = "";
      this.newAnswer = "";
    },
    removeTag(item, tags) {
      tags.splice(tags.indexOf(item), 1);
    },
    async saveInfo() {
      this.$vs.loading({
        background: "primary",
        color: "#fff",
        container: "#save-button",
        scale: 0.45,
      });
      this.generalInfo.style.borderRadius = parseInt(
        this.generalInfo.style.borderRadius
      );
      const dto = {
        ...this.generalInfo,
        capacity: parseInt(this.generalInfo.capacity),
        size: parseInt(this.generalInfo.size),
      };
      this.$store
        .dispatch("venues/updateGeneralInfo", dto)
        .then((/*resp*/) => {
          this.$vs.notify({
            color: "success",
            title: "Success",
            text: "General info saved",
          });
        })
        .catch((err) => {
          this.$vs.notify({
            color: "danger",
            title: "Error",
            text: "Could not save general info: " + err,
          });
        })
        .finally(() => {
          this.$vs.loading.close("#save-button > .con-vs-loading");
        });
    },
  },
  async mounted() {
    this.$vs.loading();
    await this.$store.dispatch("venues/getGeneralInfo");

    console.log("received", this.generalInfo);

    this.$vs.loading.close();
  },
};
</script>

<style lang="scss" scoped>
.con-chips--remove-all {
  display: none;
}
</style>